// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   MdAdd,
//   MdVisibility,
//   MdEdit,
//   MdDelete,
//   MdChevronLeft,
//   MdChevronRight,
//   MdFirstPage,
//   MdLastPage,
// } from "react-icons/md";
// import PageLayout from "components/PageFromLayout";
// import Modal from "components/common/Modal";
// import ConfirmModal from "components/common/ConfirmModal";
// import CouponForm from "components/Coupon/CouponForm";
// import { getCompaniesDrobdown } from "api/company.api";
// import {
//   getCoupons,
//   createCoupon,
//   updateCoupon,
//   deleteCoupon,
// } from "api/coupon.api";

// export default function Coupons() {
//   const [data, setData] = useState([]);
//   const [alert, setAlert] = useState("");
//   const [formAlert, setFormAlert] = useState("");
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   // Modal & Loading States
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingCoupon, setEditingCoupon] = useState(null);
//   const [deleteId, setDeleteId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [eventList, setEventList] = useState(false);
//   const [userId, setUserId] = useState("");

//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   const fetchData = async () => {
//     try {
//       const res = await getCoupons(selectedOrganizer);
//       setData(res.data || res || []);
//       const event = await getCompaniesDrobdown();
//       setEventList(event.data);
//     } catch (error) {
//       console.error("Failed to fetch coupons:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     const userData = JSON.parse(localStorage.getItem("userData"));
//     setUserId(userData.userId);
//     const handleOrganizerChange = (e) => {
//       setSelectedOrganizer(e.detail);
//     };
//     window.addEventListener("companyChanged", handleOrganizerChange);
//     return () =>
//       window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);

//   const filteredData = data.filter((item) => {
//     return (
//       item.couponName?.toLowerCase().includes(search.toLowerCase()) ||
//       item.appliesTo?.toLowerCase().includes(search.toLowerCase()) ||
//       item.usageType?.toLowerCase().includes(search.toLowerCase())
//     );
//   });

//   const totalPages = Math.ceil(filteredData.length / limit);
//   const startIndex = (page - 1) * limit;
//   const paginatedData = filteredData.slice(startIndex, startIndex + limit);

//   const formSubmit = async (formData) => {
//     try {
//       if (!editingCoupon) {
//         const payload = {
//           ...formData,
//           created_by: userId,
//         };

//         await createCoupon(payload);
//         setAlert("Coupon created successfully");
//       } else {
//         const payload = {
//           ...formData,
//           updated_by: userId,
//         };

//         await updateCoupon(editingCoupon._id, payload);
//         setAlert("Coupon updated successfully");
//       }

//       setIsModalOpen(false);
//       setEditingCoupon(null);
//       fetchData();
//     } catch (error) {
//       console.error("Form submit error:", error);
//       setFormAlert(error.response?.data?.message || "Failed to save coupon.");
//     }
//   };

//   // Handle Delete using ConfirmModal
//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       await deleteCoupon(deleteId);
//       setAlert("Coupon deleted successfully");
//       setDeleteId(null);
//       fetchData();
//     } catch (error) {
//       console.error("Delete error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <PageLayout
//         title={"Coupon"}
//         subtitle={
//           "Manage all coupons on the platform. Review, edit, search, and update their profiles."
//         }
//       >
//         <div className="flex h-[calc(100vh-140px)] flex-col">
//           {/* Top Control Bar */}
//           <div className="mb-5 flex shrink-0 flex-wrap items-center justify-between gap-3">
//             <input
//               type="text"
//               placeholder="Search coupons..."
//               className="search-field"
//               value={search}
//               onChange={(e) => {
//                 setSearch(e.target.value);
//                 setPage(1);
//               }}
//             />

//             <button
//               className="btn-primary"
//               onClick={() => {
//                 setEditingCoupon(null);
//                 setFormAlert("");
//                 setIsModalOpen(true);
//               }}
//             >
//               <MdAdd className="text-base" />
//               Create Coupon
//             </button>
//           </div>

//           {/* --- TABLE CONTAINER --- */}
//           <div className="table-card flex flex-1 flex-col overflow-hidden">
//             {/* <table className="custom-table">

//             </table> */}

//             <div className="table-scroll-body flex-1 overflow-y-auto">
//               <table className="custom-table">
//                 <thead className="custom-table-header">
//                   <tr>
//                     <th className="col-index">#</th>
//                     <th className="col-title">Coupon Name</th>
//                     <th className="col-category">Discount (%)</th>
//                     <th className="col-country">Usage Limit</th>
//                     <th className="col-country">Applies To</th>
//                     <th className="col-status">Status</th>
//                     <th className="col-actions">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paginatedData.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan="7"
//                         className="custom-table-cell"
//                         style={{ textAlign: "center", padding: "2.5rem" }}
//                       >
//                         No coupons found
//                       </td>
//                     </tr>
//                   ) : (
//                     paginatedData.map((item, index) => {
//                       const isActive =
//                         typeof item.status === "boolean"
//                           ? item.status
//                           : String(item.status).toLowerCase() === "active";

//                       return (
//                         <tr key={item._id} className="custom-table-row">
//                           <td className="custom-table-cell col-index">
//                             {startIndex + index + 1}
//                           </td>
//                           <td className="custom-table-cell col-title font-medium">
//                             {item.couponName}
//                           </td>
//                           <td className="custom-table-cell col-category">
//                             {item.discountPercentage}%
//                           </td>
//                           <td className="custom-table-cell col-country capitalize">
//                             {item.usageType === "once"
//                               ? "Single Use"
//                               : "Multiple Uses"}
//                           </td>

//                           <td className="custom-table-cell col-country">
//                             {item.appliesTo === "all"
//                               ? "All Events"
//                               : `Specific (${
//                                   item.selectedEvents?.length || 0
//                                 })`}
//                           </td>
//                           <td className="custom-table-cell col-status">
//                             <span
//                               className={`badge ${
//                                 isActive ? "badge-active" : "badge-inactive"
//                               }`}
//                             >
//                               {isActive ? "Active" : "Inactive"}
//                             </span>
//                           </td>
//                           <td className="custom-table-cell col-actions">
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 gap: "0.5rem",
//                               }}
//                             >
//                               <button
//                                 onClick={() => {
//                                   setEditingCoupon(item);
//                                   setFormAlert("");
//                                   setIsModalOpen(true);
//                                 }}
//                                 style={{
//                                   color: "#2563eb",
//                                   background: "none",
//                                   border: "none",
//                                   cursor: "pointer",
//                                 }}
//                               >
//                                 <MdEdit size={16} />
//                               </button>
//                               <button
//                                 onClick={() => setDeleteId(item._id)}
//                                 style={{
//                                   color: "#ef4444",
//                                   background: "none",
//                                   border: "none",
//                                   cursor: "pointer",
//                                 }}
//                               >
//                                 <MdDelete size={16} />
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* --- PAGINATION FOOTER --- */}
//           <div className="mt-4 flex shrink-0 items-center justify-between px-1 text-xs text-gray-500">
//             <span>
//               Showing{" "}
//               <span className="font-semibold text-gray-700">
//                 {filteredData.length === 0 ? 0 : startIndex + 1}-
//                 {Math.min(page * limit, filteredData.length)}
//               </span>{" "}
//               of{" "}
//               <span className="font-semibold text-gray-700">
//                 {filteredData.length}
//               </span>{" "}
//               coupons
//             </span>

//             <div className="flex items-center gap-2">
//               <select
//                 value={limit}
//                 onChange={(e) => {
//                   setLimit(Number(e.target.value));
//                   setPage(1);
//                 }}
//                 className="rounded-lg border bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700"
//               >
//                 <option value={10}>10 / page</option>
//                 <option value={25}>25 / page</option>
//                 <option value={50}>50 / page</option>
//               </select>

//               <div className="flex items-center gap-1">
//                 <button disabled={page === 1} onClick={() => setPage(1)}>
//                   <MdFirstPage className="text-base" />
//                 </button>
//                 <button
//                   disabled={page === 1}
//                   onClick={() => setPage((p) => p - 1)}
//                 >
//                   <MdChevronLeft className="text-base" />
//                 </button>
//                 <span className="px-2 font-semibold">
//                   {page} / {totalPages || 1}
//                 </span>
//                 <button
//                   disabled={page === totalPages || totalPages === 0}
//                   onClick={() => setPage((p) => p + 1)}
//                 >
//                   <MdChevronRight className="text-base" />
//                 </button>
//                 <button
//                   disabled={page === totalPages || totalPages === 0}
//                   onClick={() => setPage(totalPages)}
//                 >
//                   <MdLastPage className="text-base" />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* --- ADD / EDIT MODAL --- */}
//         <Modal
//           open={isModalOpen}
//           title={editingCoupon ? "Edit Coupon" : "Add Coupon"}
//           onClose={() => {
//             setIsModalOpen(false);
//             setEditingCoupon(null);
//           }}
//         >
//           <CouponForm
//             initialData={editingCoupon}
//             onSubmit={formSubmit}
//             alert={formAlert}
//             setAlert={setFormAlert}
//             eventOptions={eventList}
//           />
//         </Modal>

//         {/* --- CONFIRM DELETE MODAL --- */}
//         <ConfirmModal
//           open={Boolean(deleteId)}
//           title="Delete Coupon"
//           message="This action cannot be undone. Do you want to continue?"
//           confirmText="Delete"
//           loading={loading}
//           onConfirm={handleDelete}
//           onCancel={() => setDeleteId(null)}
//         />
//       </PageLayout>
//     </>
//   );
// }

import { useEffect, useState, useCallback, useRef } from "react";
import {
  MdSearch,
  MdAddBox,
  MdMoreVert,
  MdEdit,
  MdDelete,
} from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import Modal from "components/common/Modal";
import ConfirmModal from "components/common/ConfirmModal";
import CouponForm from "components/Coupon/CouponForm";
import Alert from "components/common/Alert";
import CustomButton from "components/CustomButton";
import { InputField } from "components/FormFields";
import Toast from "components/Toast";

import { getCompaniesDrobdown } from "api/company.api";
import {
  getCoupons,
  createCoupon,
  updateCoupon,
  deleteCoupon,
} from "api/coupon.api";

function CouponRow({
  item,
  index,
  startIndex,
  onEdit,
  onAskDelete,
  openDropdownId,
  setOpenDropdownId,
  openUpward,
  setOpenUpward,
  dropdownRef,
}) {
  const isMenuOpen = openDropdownId === item._id;

  const isActive =
    typeof item.status === "boolean"
      ? item.status
      : String(item.status).toLowerCase() === "active";

  const handleToggleMenu = (e) => {
    e.stopPropagation();
    if (isMenuOpen) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      if (spaceBelow < 150) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }

      setOpenDropdownId(item._id);
    }
  };

  return (
    <tr className="custom-table-row">
      <td className="custom-table-cell font-medium text-gray-500">
        {startIndex + index + 1}
      </td>
      <td className="custom-table-cell font-medium text-gray-800">
        {item.couponName || "N/A"}
      </td>
      <td className="custom-table-cell text-gray-700">
        {item.discountPercentage}%
      </td>
      <td className="custom-table-cell capitalize text-gray-700">
        {item.usageType === "once" ? "Single Use" : "Multiple Uses"}
      </td>
      <td className="custom-table-cell text-gray-700">
        {item.appliesTo === "all"
          ? "All Events"
          : `Specific (${item.selectedEvents?.length || 0})`}
      </td>
      <td className="custom-table-cell text-center">
        <span
          className={`inline-block rounded-[8px] px-3 py-1 text-xs font-semibold ${
            isActive
              ? "bg-[#dcfce7] text-[#16a34a]"
              : "bg-[#f1f5f9] text-[#64748b]"
          }`}
        >
          {isActive ? "Active" : "Inactive"}
        </span>
      </td>

      {/* Action Dropdown Menu Cell */}
      <td className="custom-table-cell relative text-center">
        <button onClick={handleToggleMenu} className="action-menu-btn">
          <MdMoreVert className="text-lg" />
        </button>

        {isMenuOpen && (
          <div
            ref={dropdownRef}
            className={`action-dropdown-menu ${
              openUpward ? "menu-bottom" : "menu-top"
            }`}
          >
            <button
              onClick={() => {
                onEdit(item);
                setOpenDropdownId(null);
              }}
              className="action-dropdown-item"
            >
              <MdEdit className="text-base" />
              Edit
            </button>

            <div className="action-dropdown-divider" />

            <button
              onClick={() => {
                onAskDelete(item._id);
                setOpenDropdownId(null);
              }}
              className="action-dropdown-item"
            >
              <MdDelete className="text-base" />
              Delete
            </button>
          </div>
        )}
      </td>
    </tr>
  );
}

export default function Coupons() {
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState("");
  const [formAlert, setFormAlert] = useState("");
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // Modal & Loading States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCoupon, setEditingCoupon] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [eventList, setEventList] = useState(false);
  const [userId, setUserId] = useState("");

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  // Close action dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Debounce Search Input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getCoupons(selectedOrganizer);
      setData(res.data || res || []);
      const event = await getCompaniesDrobdown();
      setEventList(event.data);
    } catch (error) {
      console.error("Failed to fetch coupons:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [selectedOrganizer]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (userData?.userId) {
      setUserId(userData.userId);
    }
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };
    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  // Client-Side Search Filtering
  const filteredData = data.filter((item) => {
    const query = debouncedSearch.toLowerCase();
    return (
      item.couponName?.toLowerCase().includes(query) ||
      item.appliesTo?.toLowerCase().includes(query) ||
      item.usageType?.toLowerCase().includes(query)
    );
  });

  const totalEntries = filteredData.length;
  const totalPages = Math.ceil(totalEntries / limit) || 1;
  const startIndex = (page - 1) * limit;
  const paginatedData = filteredData.slice(startIndex, startIndex + limit);

  const formSubmit = async (formData) => {
    try {
      console.log("Form Data Submitted:", editingCoupon);
      if (!editingCoupon) {
        const payload = {
          ...formData,
          created_by: userId,
        };

        await createCoupon(payload);
        setToast({
          open: true,
          title: "Success",
          message: "Coupon created successfully",
          type: "success",
        });
        // setAlert("Coupon created successfully");
      } else {
        const payload = {
          ...formData,
          updated_by: userId,
        };

        await updateCoupon(editingCoupon._id, payload);
        setToast({
          open: true,
          title: "Success",
          message: "Coupon updated successfully",
          type: "success",
        });
      }

      setIsModalOpen(false);
      setEditingCoupon(null);
      fetchData();
    } catch (error) {
      console.error("Form submit error:", error);
      setFormAlert(error.response?.data?.message || "Failed to save coupon.");
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await deleteCoupon(deleteId);
      setToast({
        open: true,
        title: "Success",
        message: "Coupon deleted successfully",
        type: "success",
      });
      // setAlert("Coupon deleted successfully");
      setDeleteId(null);
      fetchData();
    } catch (error) {
      setToast({
        open: true,
        title: "Failure",
        message: "Failed to delete coupon.",
        type: "error",
      });
      console.error("Delete error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <TablePageLayout>
      <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col">
          <InputField
            label="SEARCH"
            name="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search coupons..."
            icon={<MdSearch className="text-lg text-gray-400" />}
          />
        </div>

        <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
          <CustomButton
            label="Create Coupon"
            icon={MdAddBox}
            iconPos="right"
            variant="solid"
            color="#02a9e0"
            onClick={() => {
              setEditingCoupon(null);
              setFormAlert("");
              setIsModalOpen(true);
            }}
          />
        </div>
      </div>

      {alert && (
        <Alert
          type="success"
          message={alert}
          onClose={() => setAlert("")}
          autoClose
        />
      )}

      {loading && data.length === 0 ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading coupons...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <div className="table-scroll-body">
            <table className="custom-table">
              <thead className="custom-table-header">
                <tr>
                  <th className="w-12">#</th>
                  <th>Coupon Name</th>
                  <th>Discount (%)</th>
                  <th>Usage Limit</th>
                  <th>Applies To</th>
                  <th className="text-center">Status</th>
                  <th className="w-16 text-center"></th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length === 0 ? (
                  <tr>
                    <td
                      colSpan="7"
                      className="custom-table-cell py-12 text-center text-gray-500"
                    >
                      No coupons found
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((item, index) => (
                    <CouponRow
                      key={item._id}
                      item={item}
                      index={index}
                      startIndex={startIndex}
                      onEdit={(coupon) => {
                        setEditingCoupon(coupon);
                        setFormAlert("");
                        setIsModalOpen(true);
                      }}
                      onAskDelete={setDeleteId}
                      openDropdownId={openDropdownId}
                      setOpenDropdownId={setOpenDropdownId}
                      openUpward={openUpward}
                      setOpenUpward={setOpenUpward}
                      dropdownRef={dropdownRef}
                    />
                  ))
                )}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={page}
            totalPages={totalPages}
            totalEntries={totalEntries}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => {
              setLimit(newLimit);
              setPage(1);
            }}
          />
        </div>
      )}

      {/* Add / Edit Modal */}
      <Modal
        open={isModalOpen}
        title={editingCoupon ? "Edit Coupon" : "Create Coupon"}
        onClose={() => {
          setIsModalOpen(false);
          setEditingCoupon(null);
        }}
      >
        <CouponForm
          initialData={editingCoupon}
          onSubmit={formSubmit}
          alert={formAlert}
          setAlert={setFormAlert}
          eventOptions={eventList}
        />
      </Modal>

      {/* Confirm Delete Modal */}
      <ConfirmModal
        open={Boolean(deleteId)}
        title="Delete Coupon"
        message="This action cannot be undone. Do you want to continue?"
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      />
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1500}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
        }}
      />
    </TablePageLayout>
  );
}
